import { Text } from '@mntn/ui-components'
import { formatMoney } from './utils'

interface AllocationBreakdownProps {
  unallocatedBudget: number
  underDeliveredAmount: number
  neverAllocatedAmount: number
  hasUnderDelivery: boolean
  textClassName?: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const AllocationBreakdown: React.FC<AllocationBreakdownProps> = ({
  unallocatedBudget,
  underDeliveredAmount,
  neverAllocatedAmount,
  hasUnderDelivery,
  textClassName,
}) => (
  <>
    <Text variant="base-sm" className={textClassName}>
      {formatMoney(unallocatedBudget)} remaining to allocate.
    </Text>
    <div className="flex flex-col">
      {hasUnderDelivery && (
        <Text variant="base-sm" className={textClassName}>
          • {formatMoney(underDeliveredAmount)} under delivered
        </Text>
      )}
      {neverAllocatedAmount > 0 && hasUnderDelivery && (
        <Text variant="base-sm" className={textClassName}>
          • {formatMoney(neverAllocatedAmount)} remaining from original order
        </Text>
      )}
    </div>
  </>
)
